import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { useDeliveryAppContext } from '@/context/deliveryApp/DeliveryAppContext'

export const InfoModal = ({ isOpen, closeModal }) => {
  const { ordersToday } = useDeliveryAppContext()
  const nextOrderToDeliver =
    ordersToday?.find((order) => order?.status_delivery_van === 'pending') ||
    null

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="bg-black/50 dark:bg-gray-darkMode/75 fixed inset-0" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="rounded-2xl dark:bg-black-darkMode flex flex-col items-center justify-between w-full h-auto max-w-md p-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl">
                  <Dialog.Title
                    as="h3"
                    className="dark:text-white-darkMode w-full p-3 mb-3 text-lg font-medium leading-6 text-center text-gray-700 border-b"
                  >
                    Validación Presencial
                  </Dialog.Title>

                  <p className="dark:text-gray-300 font-extralight mb-2 text-sm text-left text-gray-500">
                    Esta venta ha sido marcada como una venta con potencial
                    riesgo. Es obligatorio realizar la validación presencial del
                    cliente.
                  </p>
                  <p className="dark:text-gray-300 font-extralight w-full mb-2 text-sm text-left text-gray-500">
                    Para realizarla, debe seguir los siguientes pasos:
                  </p>
                  <ul className="dark:text-gray-300 mb-6 text-sm font-light text-left text-gray-500">
                    <li className="mb-2">
                      <span className="font-bold">1.</span> Solicitar la{' '}
                      <span className="font-bold">tarjeta de crédito</span> y
                      verificar que los primeros seis dígitos y los últimos
                      cuatro coincidan con{' '}
                      <span className="text-orange-primary font-bold">
                        {nextOrderToDeliver?.payments?.[0].bin}
                        <span className="text-lg font-normal">-xxxxxxx-</span>
                        {nextOrderToDeliver?.payments?.[0].last_four_digit}
                      </span>
                      .
                    </li>
                    <li className="mb-2">
                      <span className="font-bold">2.</span> Solicitar el{' '}
                      <span className="font-bold">
                        DNI: {nextOrderToDeliver?.payments?.[0]?.cardholder}
                      </span>{' '}
                      y comprobar que coincida la foto con la persona que esta
                      recibiendo el producto.
                    </li>
                    <li className="mb-2">
                      <span className="font-bold">3.</span> Verificar que el
                      nombre del documento coincida con el nombre de la tarjeta
                      de crédito
                    </li>
                  </ul>

                  <div className="flex flex-col w-full">
                    <button
                      type="button"
                      className="dark:bg-black-darkMode text-payne-primary hover:opacity-80 dark:text-gray-400 inline-flex justify-center px-4 py-2 mt-2 text-sm font-medium bg-white rounded-md"
                      onClick={closeModal}
                    >
                      Cancelar
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
